module.exports = __webpack_public_path__ + "img/cloud-load-icon.9ff28be3.svg";